/* eslint-disable indent */
import { APIs } from "../../utils/worker";
import API from "../../api";

const { baseURLInnofulfill } = APIs;

const urls = {
  BASE_RATE_CARD: `${baseURLInnofulfill}/ratecard/default`,
  BASE_RATE_SLAB: `${baseURLInnofulfill}/ratecard/rateslab/default`,
  GET_DEFAULT_RATE_MATRIX: `${baseURLInnofulfill}/ratecard/template/default`,
  ZONE_URL: `${baseURLInnofulfill}/zone-mapping/zone`,
  ASSIGN_RATE_CARD: `${baseURLInnofulfill}/ratecard/template/assign`,
  CLONE_RATE_CARD: `${baseURLInnofulfill}/ratecard/template/clone`,
  PATCH_ZONE_RATECARD: `${baseURLInnofulfill}/zone-mapping/zone-ratecard`,
};

const handleApiRequest = async (
  url,
  method,
  data = null,
  headersMethod = "get"
) => {
  try {
    const payload = data;

    const headers = headersMethod;

    let response = await API.Api(url)[method](payload, headers);
    return response;
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} request to ${url}:`, error);
    throw error;
  }
};

const handleApiRequestCustomHeader = async (
  url,
  method,
  data = null,
  header
) => {
  try {
    const payload = data;
    let response = await API.Api(url)[method](payload, header);
    return response;
  } catch (error) {
    console.error(`Error in ${method.toUpperCase()} request to ${url}:`, error);
    throw error;
  }
};
export const masterRateCardAPI = {
  getDefaultRateMatrix: () =>
    handleApiRequest(urls.GET_DEFAULT_RATE_MATRIX, "get"),

  createRate: (payload) =>
    handleApiRequest(urls.BASE_RATE_CARD, "post", payload),

  patchRate: (id, payload) =>
    handleApiRequest(`${urls.BASE_RATE_CARD}/${id}`, "patch", payload),

  putRate: (id, payload) =>
    handleApiRequest(`${urls.BASE_RATE_CARD}/approval`, "put", payload),

  getAllRateList: async (params) => {
    const queryParams = new URLSearchParams(params).toString();

    return handleApiRequest(`${urls.BASE_RATE_CARD}?${queryParams}`, "get");
  },

  getRateById: (id) => handleApiRequest(`${urls.BASE_RATE_CARD}/${id}`, "get"),
  assignRateCard: (payload) =>
    handleApiRequest(urls.ASSIGN_RATE_CARD, "post", payload),
  cloneRateCard: (payload) =>
    handleApiRequest(urls.CLONE_RATE_CARD, "post", payload),
};

export const masterSlabAPI = {
  createSlab: (payload) =>
    handleApiRequest(urls.BASE_RATE_SLAB, "post", payload),

  patchSlab: (id, payload) =>
    handleApiRequest(`${urls.BASE_RATE_SLAB}/${id}`, "patch", payload),

  putSlab: (id, payload) =>
    handleApiRequest(`${urls.BASE_RATE_SLAB}/approval`, "put", payload),

  getAllSlabList: async (params) => {
    //const queryParams = new URLSearchParams(params).toString();
    const queryParams = params
      ? `?${new URLSearchParams(params).toString()}`
      : "";
    return handleApiRequest(`${urls.BASE_RATE_SLAB}${queryParams}`, "get");
  },

  getSlabById: (id) => handleApiRequest(`${urls.BASE_RATE_SLAB}/${id}`, "get"),
};

export const zoneAPI = {
  getAllZoneList: async (params, header) => {
    const queryParams = params
      ? `?${new URLSearchParams(params).toString()}`
      : "";

    return handleApiRequestCustomHeader(
      `${urls.ZONE_URL}${queryParams}`,
      "getCustomHeader",
      header
    );
  },
  getZoneById: (id) =>
    handleApiRequestCustomHeader(`${urls.ZONE_URL}/${id}`, "get"),
  createZone: (payload, headers) =>
    handleApiRequestCustomHeader(
      urls.ZONE_URL,
      "postCustomHeader",
      payload,
      headers
    ),

  cloneZone: (payload, headers) =>
    handleApiRequestCustomHeader(
      `${urls.ZONE_URL}/clone`,
      "postCustomHeader",
      payload,
      headers
    ),

  patchZone: (id, payload) =>
    handleApiRequestCustomHeader(
      `${urls.ZONE_URL}/${id}`,
      "patchCustomHeader",
      payload
    ),

  patchZoneRateCard: (payload) =>
    handleApiRequestCustomHeader(
      urls.PATCH_ZONE_RATECARD,
      "patchCustomHeader",
      payload
    ),

  deleteZone: (id) =>
    handleApiRequestCustomHeader(`${urls.ZONE_URL}/${id}`, "deleteHeader"),
};
